<template>
    <div class="tab-pane fade" id="list-settings-designations" role="tabpanel" aria-labelledby="list-settings-designations-list">
        <div v-if="create_designation_form">
            <h4>
                <div class="row">
                    <div class="col-lg-6" style="align-self: center;">
                        {{ create_designation_form ? "Create Designation" : "All Designations" }}
                    </div>
                    <div class="col-lg-6">
                        <div class="row">
                            <div v-if="create_designation_form" class="col-lg-3 offset-9 py-4 text-right">
                                <button @click="create_designation_form = false" style="float: right;" type="button" class="btn btn-sm btn-danger m-1 text-white btn-raised ripple">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </h4>
            <div class="main-content mt-0 px-0">
                <div>
                    <v-form @submit.prevent>
                        <div class="container-fluid">
                            <v-row>
                                <v-col cols="12" sm="6" md="6" class="remove-hint">
                                    <span style="color: #111d5e;">Designation Description <i class="fal fa-asterisk" style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"></i></span>
                                    <v-text-field v-model="designation_form.designation_title" placeholder="Enter the designation title" solo class="mt-2" dense></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="remove-hint">
                                    <span style="color: #111d5e;">Description <i class="fal fa-asterisk" style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"></i></span>
                                    <v-text-field v-model="designation_form.description" placeholder="Enter the designation description" solo class="mt-2" dense> </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="remove-hint">
                                    <span style="color: #111d5e;">Hourly Rate <i class="fal fa-asterisk" style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"></i></span>
                                    <v-text-field type="number" v-model="designation_form.rate" placeholder="Enter the hourly rate" solo class="mt-2" dense> </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" offset-md="3" class="remove-hint">
                                    <button
                                        @click="createDesignationLoading ? null : create_designation()"
                                        style="width: 99%;"
                                        type="button"
                                        class="btn btn-secondary m-1 text-white btn-raised ripple"
                                    >
                                        {{ createDesignationText }}
                                        <v-icon
                                            :style="!createDesignationLoading ? 'display: none;' : 'color: #fff; padding: 0px 10px; font-size: 16px;'"
                                        >
                                            fal fa-circle-notch fa-spin
                                        </v-icon>
                                    </button>
                                </v-col>
                            </v-row>
                        </div>
                    </v-form>
                </div>
            </div>
        </div>
        <div v-else>
            <h4>
                <div class="row">
                    <div class="col-lg-6" style="align-self: center;">
                        Designations Management
                    </div>
                    <div class="col-lg-6" v-if="permissionIsAssigned('designation-create')">
                        <div class="row">
                            <div class="col-lg-3 offset-9 py-4">
                                <button @click="create_designation_form = true" style="float: right;" type="button" class="btn btn-sm btn-secondary m-1 text-white btn-raised ripple">
                                    Create Designation
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </h4>
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col" class="text-left">
                                Designation Name
                            </th>
                            <th scope="col" class="text-left">
                                Designation Description
                            </th>
                            <th scope="col" class="text-left">
                                Hourly Rate
                            </th>
                            <th
                                v-if="permissionIsAssigned('designation-update') || permissionIsAssigned('designation-delete')"
                                scope="col"
                                style="width: 10px;"
                            >
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="d in authDesignations" :key="d.id">
                            <td class="text-left">{{ d.title }}</td>
                            <td class="text-left">{{ d.description }}</td>
                            <td class="text-left">${{ parseFloat(d.rate) | number_with_commas }}</td>
                            <td
                                v-if="permissionIsAssigned('designation-update') || permissionIsAssigned('designation-delete')"
                                style="padding-top: 13px;"
                                class="employee-options"
                            >
                                <div class="row">
                                    <i
                                        v-if="permissionIsAssigned('designation-update')"
                                        @click="launch_edit_designation(d)"
                                        class="col-3 py-4 text-center fal fa-edit mr-2"
                                        style="color: #069 !important; font-size: 125%; cursor: pointer;"
                                    ></i>
                                    <i
                                        v-if="permissionIsAssigned('designation-delete')"
                                        @click="delete_designation(d)"
                                        class="col-3 py-4 text-center fal fa-trash ml-2"
                                        style="color: #069 !important; font-size: 125%; cursor: pointer;"
                                    ></i>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <v-dialog v-model="designation_edit_dialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Edit Designation</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form @submit.prevent>
                            <div class="container-fluid">
                                <v-row>
                                    <v-col cols="12" sm="6" md="6" class="remove-hint">
                                        <v-text-field dense v-model="edit_designation_form.designation_title" placeholder="Designation Title" solo class="mt-2"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" class="remove-hint">
                                        <v-text-field dense v-model="edit_designation_form.description" placeholder="Designation Description" solo class="mt-2"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" class="remove-hint">
                                        <v-text-field type="number" dense v-model="edit_designation_form.rate" placeholder="Hourly Rate" solo class="mt-2"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" offset-md="3" offset-sm="3" class="remove-hint">
                                        <button
                                            @click="edit_designation_submit ? null : update_designation()"
                                            style="width: 100%;"
                                            type="button"
                                            class="btn btn-secondary m-1 ripple"
                                        >
                                            {{ edit_designation_text }}
                                            <v-icon
                                                :style="!edit_designation_submit ? 'display: none;' : 'color: #fff; padding: 0px 10px; font-size: 16px;'"
                                            >
                                                fal fa-circle-notch fa-spin
                                            </v-icon>
                                        </button>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="designation_edit_dialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import { BASE_URL } from "@/main";
import { mapActions, mapGetters } from 'vuex';
export default {
    props: {},
    data() {
        return {
            create_designation_form: false,
            designation_form: {
                designation_title: "",
                description: "",
                rate: "",
            },
            edit_designation_form: {
                id: "",
                designation_title: "",
                description: "",
                rate: "",
            },
            edit_designation_text: "Update",
            edit_designation_submit: false,
            createDesignationText: "Create",
            createDesignationLoading: false,
            designation_edit_dialog: false,
        }
    },
    computed: {
        ...mapGetters([
            'authCompanyData',
            'authDesignations'
        ])
    },
    methods: {
        ...mapActions([
            'fetch_all_designations'
        ]),
        launch_edit_designation(d) {
            this.edit_designation_form.id = d.id;
            this.edit_designation_form.designation_title = d.title;
            this.edit_designation_form.description = d.description;
            this.edit_designation_form.rate = d.rate;
            this.designation_edit_dialog = true;
        },
        delete_designation(d) {
            const _this = this;
            const Toast = _this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", _this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", _this.$swal.resumeTimer);
                },
            });

            _this.$swal.fire({
                title: "Are you sure you want to delete this designation?",
                showCancelButton: true,
                confirmButtonText: `Yes, Delete`,
            })
            .then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    axios.post(`${BASE_URL}deletedesignation`, {
                        ids: [
                            {
                                id: d.id,
                            },
                        ],
                    })
                    .then(function () {
                        Toast.fire({
                            icon: "success",
                            title: "The designation deleted successfully",
                        });
                    })
                    .catch(function (error) {
                        Toast.fire({
                            icon: "error",
                            title: "Designation couldn't be deleted",
                        });
                        console.log(error);
                    })
                    .then(function () {
                        _this.fetch_all_designations();
                    });
                }
            });
        },
        update_designation() {
            const _this = this;
            _this.edit_designation_text = "";
            _this.edit_designation_submit = true;
            const Toast = _this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", _this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", _this.$swal.resumeTimer);
                },
            });
            axios.post(`${BASE_URL}editdesignation`, {
                company_id: _this.authCompanyData.id,
                id: _this.edit_designation_form.id,
                designation_title: _this.edit_designation_form.designation_title,
                description: _this.edit_designation_form.description,
                rate: _this.edit_designation_form.rate,
            })
            .then(function () {
                Toast.fire({
                    icon: "success",
                    title: "The designation has been updated successfully",
                });
                _this.edit_designation_form.id = null;
                _this.edit_designation_form.designation_title = "";
                _this.edit_designation_form.description = "";
                _this.edit_designation_form.rate = "";
                _this.fetch_all_designations();
                _this.designation_edit_dialog = false;
            })
            .catch(function (error) {
                const errors = error.response.data.error || null;
                Toast.fire({
                    icon: "error",
                    title: errors
                        ? typeof errors === "string"
                            ? errors
                            : "The designation couldn't be updated"
                        : null || error.response.data.error || error.response.data.message || "The designation couldn't be updated",
                });
            })
            .then(function () {
                _this.edit_designation_submit = false;
                _this.edit_designation_text = "Update";
            });
        },
        create_designation() {
            const _this = this;
            _this.createDesignationText = "";
            _this.createDesignationLoading = true;

            const Toast = _this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", _this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", _this.$swal.resumeTimer);
                },
            });

            axios.post(`${BASE_URL}createdesignation`, {
                company_id: _this.authCompanyData.id,
                designation_title: _this.designation_form.designation_title,
                description: _this.designation_form.description,
                rate: _this.designation_form.rate,
            })
            .then(function () {
                Toast.fire({
                    icon: "success",
                    title: "The designation " + _this.designation_form.designation_title + " was added successfully",
                });
                _this.designation_form.designation_title = "";
                _this.designation_form.description = "";
                _this.fetch_all_designations();
                _this.create_designation_form = false;
            })
            .catch(function (error) {
                let errors = error.response.data.error || null;
                Toast.fire({
                    icon: "error",
                    title: errors
                        ? typeof errors === "string"
                            ? errors
                            : null || errors.designation_title
                            ? errors.designation_title[0]
                            : null || errors.description
                            ? errors.description[0]
                            : null || errors.rate
                            ? errors.rate[0]
                            : null
                        : null || error.response.data.error || error.response.data.message || "The designation could not be added",
                });
            })
            .then(function () {
                _this.createDesignationLoading = false;
                _this.createDesignationText = "Submit";
            });
        }
    }
}
</script>

<style>

</style>